import { render, staticRenderFns } from "./OpzioniReintegri.vue?vue&type=template&id=5b0d5d2a"
import script from "./OpzioniReintegri.vue?vue&type=script&lang=ts"
export * from "./OpzioniReintegri.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Progetti\\Filolog\\frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b0d5d2a')) {
      api.createRecord('5b0d5d2a', component.options)
    } else {
      api.reload('5b0d5d2a', component.options)
    }
    module.hot.accept("./OpzioniReintegri.vue?vue&type=template&id=5b0d5d2a", function () {
      api.rerender('5b0d5d2a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/OpzioniReintegri.vue"
export default component.exports